// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__qqmnj","content":"GlobalSearch_content__3oMzA"};